import { Routes } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { CracMapState } from './states/cracmap.state';
import { CracmapComponent } from './cracmap.component';

export const cracmapRoutes: Routes = [
    {
        path: '',
        providers: [importProvidersFrom(NgxsModule.forFeature([CracMapState]))],
        children: [
            {
                path: '',
                component: CracmapComponent,
            },
        ],
    },
];
